import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Media = () => {
  const solutions = ['Content Management Systems', 'Video Streaming Platforms', 'Digital Asset Management', 'Publishing Platforms', 'Audience Analytics', 'Ad Management'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Media & Entertainment Solutions</h1>
          <p>Content management, streaming platforms, and digital publishing software</p>
        </div>
      </section>
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Powering Digital Media</h2>
            <p>We develop scalable media platforms that handle high-traffic content delivery, manage digital assets, and provide deep audience insights. From streaming services to publishing platforms, we help media companies engage their audiences.</p>
          </div>
        </div>
      </section>
      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Media Solutions</h2></div>
          <div className="expertise-grid">{solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}</div>
        </div>
      </section>
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Build Your Media Platform</h2>
            <p>Let's discuss your digital media and entertainment needs.</p>
            <Link to="/contact"><Button variant="contained" size="large" endIcon={<ArrowForwardIcon />} sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>Contact Us</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Media;
